import Product from '@/classes/Product'

export default class OrganizationRule {
  public readonly NAME_MAX_LENGTH = 100
  public readonly EMAIL_MAX_LENGTH = 50
  public readonly DESCRIPTION_MAX_LENGTH = 500
  public readonly ADDRESS_MAX_LENGTH = 100
  public readonly CITY_MAX_LENGTH = 50
  public readonly STATE_MAX_LENGTH = 50
  public readonly COUNTRY_MAX_LENGTH = 50
  public readonly POSTAL_CODE_MAX_LENGTH = 20
  public readonly PHONE_NUMBER_MAX_LENGTH = 20
  public readonly SERIAL_NUMBER_MAX_LENGTH = 50
  public readonly FREE_LICENSETYPE_PRODUCTS: Array<string> = ['26ee028b-54dc-4d86-a73d-e86b6620dc30']
  public readonly LICENSETYPE_FREE = 'Free'
  public nameRules: Array<object> = [
    (v: string) => !!v || 'Name is Required',
    (v: string) => (v && v.length - 1 < this.NAME_MAX_LENGTH) || `Name must be less than ${this.NAME_MAX_LENGTH} characters.`,
  ]

  public emailRules: Array<object> = [
    (v: string) => !!v || 'E-mail is required',
    (v: string) => /.+@.+/.test(v) || 'E-mail must be valid',
    (v: string) => (v && v.length - 1 < this.EMAIL_MAX_LENGTH) || `Email address must be less than ${this.EMAIL_MAX_LENGTH} characters.`,
  ]

  public startDateRules: Array<object> = [(v: string) => !!v || 'Start Date is required']

  public endDateRules: Array<object> = [(v: string) => !!v || 'End Date is required']

  public serialNumberRules: Array<object> = [
    (v: string) => !!v || 'A license serial number is required',
    (v: string) => !v || v.length < this.SERIAL_NUMBER_MAX_LENGTH || `Serial Number must be less than ${this.SERIAL_NUMBER_MAX_LENGTH} characters.`,
  ]

  public licenseCountRules: Array<object> = [(v: number) => v >= 1 || 'License count must be 1 or more.']

  constructor() {}

  public dateComparator(start: string, end: string) {
    const startDate = new Date(Date.parse(start))
    const endDate = new Date(Date.parse(end))
    return startDate < endDate ? [true] : ['End date must be later than start date.']
  }
  public licenseTypeValidation(productId: string, type: number, productsList: Array<Product>, licenseTypes: Array<object>) {
    const product = productsList.find((p) => p.id === productId)
    const licenseType = licenseTypes.find((t) => t.value === type)
    if (this.FREE_LICENSETYPE_PRODUCTS.indexOf(product?.id) === -1 && licenseType?.text === this.LICENSETYPE_FREE) {
      return [`${product?.name} product cannot have license of type FREE.`]
    }
  }
}
